import { aggregationFns } from '@tanstack/react-table'

export const SRT_AggregationFns = { ...aggregationFns }
